module.exports = __webpack_public_path__ + "static/media/pemilu4.86467774.JPG";